import type { ThemeFormValues } from './ThemeEditorPanel';

/**
 * Populate a ThemeFormValues object from a theme record (preset, platform theme,
 * or org theme). Shared by admin DesignSystem page and the org-scoped
 * Design System tab so both use identical mapping logic.
 */
export function loadPresetIntoForm(theme: Record<string, any>): ThemeFormValues {
  return {
    primaryColor: theme.primaryColor || '',
    secondaryColor: theme.secondaryColor || '',
    accentColor: theme.accentColor || '',
    successColor: theme.successColor || '',
    warningColor: theme.warningColor || '',
    errorColor: theme.errorColor || '',
    infoColor: theme.infoColor || '',
    grayColor: theme.grayColor || '',
    headingFontFamily: theme.headingFontFamily || '',
    bodyFontFamily: theme.bodyFontFamily || '',
    headingFontSize: theme.headingFontSize || '',
    bodyFontSize: theme.bodyFontSize || '',
    logoUrl: theme.logoUrl || '',
    logoMarkUrl: theme.logoMarkUrl || '',
    faviconUrl: theme.faviconUrl || '',
    borderRadius: theme.borderRadius || '',
    customCss: theme.customCss || '',
    darkModeEnabled: theme.darkModeEnabled ?? true,
    dateFormat: theme.dateFormat || '',
    timeFormat: theme.timeFormat || '',
    weekStart: theme.weekStart ?? '',
    showCalendarWeeks: theme.showCalendarWeeks ?? true,
    thousandsSeparator: theme.thousandsSeparator || '',
    decimalSeparator: theme.decimalSeparator || '',
    currencySymbol: theme.currencySymbol || '',
    currencyFormat: theme.currencyFormat || '',
  };
}
